<template>
    <div>
      <el-row>
        <el-col :span="17">
          <!-- 面包屑导航区域-->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
            <el-breadcrumb-item>Development</el-breadcrumb-item>
            <el-breadcrumb-item>QA Request</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-card>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="Po Number:">
            <el-input v-model="formInline.po" placeholder="Po Number" clearable></el-input>
          </el-form-item>
          <el-form-item label="Item Number:">
            <el-input v-model="formInline.item" placeholder="Item Number" clearable></el-input>
          </el-form-item>
          <el-form-item label="QC Reports Status:">
            <el-select v-model="formInline.QCReportStatus" placeholder="Status">
              <el-option
                v-for="item in options"
                :key="item.value"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
<!--            <el-button type="primary" @click="onSubmit">Search</el-button>-->
          </el-form-item>
          <div>
            <el-form-item>
              <el-button type="primary" @click="customerDialogOpen('add')">Add</el-button>
            </el-form-item>
          </div>
        </el-form>
        <!-- CRProject 列表区域 -->
        <el-table :data="qcScheduleList" border stripe style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column fixed type="index" label="#"></el-table-column>
          <el-table-column
            fixed
            prop="po"
            label="Po Number" sortable
            width="120">
          </el-table-column>
          <el-table-column
            fixed
            prop="item" sortable
            label="Item Number"
            width="120">
          </el-table-column>
          <el-table-column
            prop="project" sortable
            label="project"
            width="120">
          </el-table-column>
          <el-table-column
            prop="supplier" sortable
            label="supplier"
            width="120">
          </el-table-column>
          <el-table-column
            prop="brand" sortable
            label="brand"
            width="120">
          </el-table-column>
          <el-table-column
            prop="orderQty" sortable
            label="orderQty"
            width="120">
          </el-table-column>
          <el-table-column
            prop="balance" sortable
            label="balance"
            width="120">
          </el-table-column>
          <el-table-column
            prop="status" sortable
            label="status"
            width="120">
          </el-table-column>
          <el-table-column
            prop="historyReport" sortable
            label="History QC Reports"
            width="180">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status==='RYA'" type="warning" size="mini"><i class="el-icon-document"></i>QC Reports</el-button>
<!--              <el-button v-else-if="scope.row.status==='LYA'" type="danger" size="mini"><i class="el-icon-document"></i>QC Reports</el-button>-->
              <el-button v-else-if="scope.row.status==='LSH'" type="success" size="mini"><i class="el-icon-document"></i>QC Reports</el-button>
              <div v-else-if="scope.row.status===' '" size="mini"></div>
              <div v-else size="mini"></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="schDate1" sortable
            label="schDate1"
            width="150">
          </el-table-column>
          <el-table-column
            prop="schDate2" sortable
            label="schDate2"
            width="150">
          </el-table-column>
          <el-table-column
            prop="schDate3" sortable
            label="schDate3"
            width="150">
          </el-table-column>
          <el-table-column
            prop="schDate4" sortable
            label="schDate4"
            width="150">
          </el-table-column>
        </el-table>
      </el-card>

      <div id="printTest">
        <el-dialog title="" :visible.sync="dialogVisible"  width="70%">
          <el-row>
            <el-col :span="4">
              <img style="width: 100%;" src="../../assets/spclogo.png" alt="">
            </el-col>
            <el-col :span="20" style="text-align: center;padding: 0 10%;"><h2 class="grid-content bg-purple">Sourcing Perfume & Cosmetic (SH) Ltd.
              Component Inspection Report</h2></el-col>
          </el-row>
          <br><br>
          <table class="table-body" cellspacing=0 cellpadding=0>
            <tbody>
            <tr>
              <td width="100%" colspan="8" class="section-header">Base Info</td>
            </tr>
            <tr>
              <td width="25%">Supplier:</td>
              <td width="25%" style="text-align: center">{{supplier.toString()}}</td>
              <td width="25%">Item Number:</td>
              <td width="25%" style="text-align: center">{{item.toString()}}</td>
            </tr>
            <tr>
              <td width="25%">PO Number:</td>
              <td width="25%" style="text-align: center">{{po.toString()}}</td>
              <td width="25%">Brand:</td>
              <td width="25%" style="text-align: center">{{brand.toString()}}</td>
            </tr>
            <tr>
              <td width="25%">Date of Inspection:</td>
              <td width="25%" style="text-align: center">{{timeNow}}</td>
              <td width="25%">Inspection Status:</td>
              <td width="25%" style="text-align: center">
                <el-select size="mini" style="width: 100%;border:none;" v-model="value" placeholder="Please select">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td width="25%">Order Quantity:</td>
              <td colspan="3" width="25%" style="text-align: center">{{orderQtySum}}({{orderQty.toString()}})</td>
            </tr>
            <tr>
              <td width="25%">Type Of Product:</td>
              <td width="25%" style="text-align: center">
                <el-select size="mini" style="width: 100%;border:none;" v-model="value" placeholder="Please select">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </td>
              <td colspan="2"></td>
            </tr>
            <tr>
              <td width="25%">Description Of Product:</td>
              <td colspan="3" width="25%" style="text-align: center">{{description.toString()}}</td>
            </tr>
            <tr>
              <td width="25%">Actual Quantity:</td>
              <td width="25%" style="text-align: center">
                <el-input size="mini" v-model="actualQuantity" placeholder="Please fill in"></el-input>
              </td>
              <td width="25%">Balance Quantity:</td>
              <td width="25%" style="text-align: center">
                <el-input size="mini" v-model="actualQuantity" placeholder="Please fill in"></el-input>
              </td>
            </tr>
            <tr>
              <td width="25%">Sampling Quantity:</td>
              <td width="25%" style="text-align: center">
                <el-input size="mini" v-model="actualQuantity" placeholder="Please fill in"></el-input>
              </td>
              <td width="25%">Sampling Cartons:</td>
              <td width="25%" style="text-align: center">
                <el-input size="mini" v-model="actualQuantity" placeholder="Please fill in"></el-input>
              </td>
            </tr>
            <tr>
              <td width="25%">Sampling Level for appearance:</td>
              <td width="25%" style="text-align: center">
                <el-select size="mini" style="width: 100%;border:none;" v-model="value" placeholder="Please select">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </td>
              <td colspan="2"></td>
            </tr>
            <tr><td colspan="4" style="height: 5px"> </td></tr>
            <tr>
              <td width="25%" style="color:#409EFF;">Final result:</td>
              <td width="25%" style="text-align: center;">
                <el-select size="mini" style="width: 100%;border:none;" v-model="value" placeholder="Please select">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </td>
              <td width="25%" colspan="2"></td>
            </tr>
            <tr><td colspan="4" style="height: 5px"> </td></tr>
            <tr>
              <td width="25%">Packaging Control:</td>
              <td colspan="3" style="text-align: center">
                <el-checkbox-group v-model="packagingControl">
                  <el-checkbox label="Pallet"></el-checkbox>
                  <el-checkbox label="Carton"></el-checkbox>
                  <el-checkbox label="Shipping mark"></el-checkbox>
                </el-checkbox-group>
              </td>
            </tr>
            <tr>
              <td width="25%">Control elements checking:</td>
              <td colspan="3" style="text-align: center">
                <el-checkbox-group v-model="controlElementsChecking">
                  <el-checkbox label="Drawing"></el-checkbox>
                  <el-checkbox label="Approved Sample"></el-checkbox>
                  <el-checkbox label="Artwork"></el-checkbox>
                  <el-checkbox label="Defect Range Board"></el-checkbox>
                  <el-checkbox label="Specification"></el-checkbox>
                  <el-checkbox label="Color Range Board"></el-checkbox>
                </el-checkbox-group>
              </td>
            </tr>
            <tr>
              <td width="25%">Artwork inspection:</td>
              <td colspan="3" style="text-align: center">
                <el-checkbox-group v-model="artworkInspection">
                  <el-checkbox label="OK"></el-checkbox>
                  <el-checkbox label="NG"></el-checkbox>
                  <el-checkbox label="NA"></el-checkbox>
                </el-checkbox-group>
              </td>
            </tr>
            <tr>
              <td width="25%">Color inspection:</td>
              <td colspan="3" style="text-align: center">
                <el-checkbox-group v-model="colorInspection">
                  <el-checkbox label="Lighter"></el-checkbox>
                  <el-checkbox label="OK"></el-checkbox>
                  <el-checkbox label="Darker"></el-checkbox>
                  <el-checkbox label="NA"></el-checkbox>
                </el-checkbox-group>
              </td>
            </tr>
            <tr><td colspan="4" style="height: 5px"> </td></tr>
            <tr>
              <td width="25%">Remark:</td>
              <td colspan="3" width="25%" style="text-align: center"></td>
            </tr>
            <tr><td colspan="4" style="height: 5px"> </td></tr>
            <tr>
              <td colspan="4" class="section-header">Appearance Inspection Level I / Level II (ISO 2859 )</td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center">Discription Of Defect</td>
              <td colspan="2" style="text-align: center">Quantity</td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center"></td>
              <td colspan="2" style="text-align: center">
                <div style="display: flex;text-align: center">
                  <div style="flex: 1;">Cr 0.65</div>
                  <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">Maj 1.5</div>
                  <div style="flex: 1;">Mir 4.0</div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center"></td>
              <td colspan="2" style="text-align: center">
                <div style="display: flex;text-align: center">
                  <div style="flex: 1;">1</div>
                  <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">2</div>
                  <div style="flex: 1;">3</div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center"></td>
              <td colspan="2" style="text-align: center">
                <div style="display: flex;text-align: center">
                  <div style="flex: 1;">1</div>
                  <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">2</div>
                  <div style="flex: 1;">3</div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: center"></td>
              <td colspan="2" style="text-align: center">
                <div style="display: flex;text-align: center">
                  <div style="flex: 1;">1</div>
                  <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">2</div>
                  <div style="flex: 1;">3</div>
                </div>
              </td>
            </tr>
            <!--        <tr>-->
            <!--          <td colspan="4">:</td>-->
            <!--        </tr>-->
            <tr>
              <td colspan="2" style="text-align: center">Total</td>
              <td colspan="2" style="text-align: center">
                <div style="display: flex;text-align: center">
                  <div style="flex: 1;">3</div>
                  <div style="flex: 1;border-left: 1px solid #999;border-right: 0.5px solid #999;">6</div>
                  <div style="flex: 1;">9</div>
                </div>
              </td>
            </tr>
            <tr><td colspan="4" style="height: 5px"> </td></tr>
            <tr>
              <td colspan="4" class="section-header">Dimensional measurement,Functional and decoration resistance test  S-2     AQL =1.5  (ISO 2859 )     </td>
            </tr>
            <tr>
              <td width="25%">Item Of Dimensional/Functional</td>
              <td colspan="3"></td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">LCL</td>
              <td width="25%" style="text-align: center">1.00</td>
              <td width="25%" style="text-align: center">0.50</td>
              <td width="25%" style="text-align: center">2.50</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">STD</td>
              <td width="25%" style="text-align: center">1.00</td>
              <td width="25%" style="text-align: center">0.50</td>
              <td width="25%" style="text-align: center">2.50</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">UCL</td>
              <td width="25%" style="text-align: center">1.00</td>
              <td width="25%" style="text-align: center">0.50</td>
              <td width="25%" style="text-align: center">2.50</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">1</td>
              <td width="25%" style="text-align: center">1.00</td>
              <td width="25%" style="text-align: center">0.50</td>
              <td width="25%" style="text-align: center">2.50</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">2</td>
              <td width="25%" style="text-align: center">1.00</td>
              <td width="25%" style="text-align: center">0.50</td>
              <td width="25%" style="text-align: center">2.50</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">Min</td>
              <td width="25%" style="text-align: center">1.00</td>
              <td width="25%" style="text-align: center">0.50</td>
              <td width="25%" style="text-align: center">2.50</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">Max</td>
              <td width="25%" style="text-align: center">1.00</td>
              <td width="25%" style="text-align: center">0.50</td>
              <td width="25%" style="text-align: center">2.50</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">Avg</td>
              <td width="25%" style="text-align: center">1.00</td>
              <td width="25%" style="text-align: center">0.50</td>
              <td width="25%" style="text-align: center">2.50</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">CPK</td>
              <td width="25%" style="text-align: center">0.22</td>
              <td width="25%" style="text-align: center">0.14</td>
              <td width="25%" style="text-align: center">-0.08</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">Result</td>
              <td width="25%" style="text-align: center">OK</td>
              <td width="25%" style="text-align: center">NG</td>
              <td width="25%" style="text-align: center">NG</td>
            </tr>
            <tr>
              <td width="25%" style="text-align: center">Conclusion</td>
              <td width="25%" style="text-align: center">OK</td>
              <td width="25%" style="text-align: center">NG</td>
              <td width="25%" style="text-align: center">NG</td>
            </tr>
            <tr><td colspan="4" style="height: 5px"> </td></tr>
            <tr>
              <td width="25%">Remark:</td>
              <td colspan="3" width="25%" style="text-align: center"></td>
            </tr>
            <tr><td colspan="4" style="height: 5px"> </td></tr>
            <tr>
              <td width="25%">Inspected By:</td>
              <td width="25%" style="text-align: center"></td>
              <td colspan="2" width="25%" style="text-align: center"></td>
            </tr>
            <tr>
              <td width="25%">Approved By:</td>
              <td width="25%" style="text-align: center"></td>
              <td colspan="2" width="25%" style="text-align: center"></td>
            </tr>
            </tbody>
            <div style="page-break-after:always"></div>
          </table>
        </el-dialog>
      </div>
    </div>
</template>

<script>
const date = new Date()
export default {
  data () {
    return {
      timeNow: date.toLocaleString('en-US', { timeZone: 'America/New_York' }),
      actualQuantity: '',
      orderQty: [],
      orderQtySum: 0,
      description: [],
      colorInspection: [],
      artworkInspection: [],
      controlElementsChecking: [],
      packagingControl: [],
      checked: true,
      item: [],
      po: [],
      supplier: [],
      brand: [],
      multipleSelection: [],
      dialogVisible: false,
      value: '',
      options: [{
        value: 'Accept'
      }, {
        value: 'Reject'
      }, {
        value: 'Pending'
      }, {
        value: 'Conditional Accept'
      }],
      qcScheduleList: [],
      formInline: {
        QCReportStatus: '',
        item: '',
        po: '',
        page: 1,
        rows: 100
      }
    }
  },
  name: 'QCSchedule',
  created () {
    this.getQCScheduleList()
  },
  methods: {
    async getQCScheduleList () {
      const { data: res } = await this.$http.get('/QCReport/getQCScheduleList', { params: this.formInline })
      this.qcScheduleList = res
    },
    customerDialogOpen () {
      this.timeNow = date.toLocaleString('en-US', { timeZone: 'America/New_York' })
      this.value = ''
      this.orderQtySum = 0
      if (this.multipleSelection.length < 1) {
        this.$notify.warning({
          title: 'Please choose at least one base info',
          message: 'Multiple pieces of information can be combined into a single report'
        })
        return
      }
      this.dialogVisible = true
      this.item = [...new Set(this.item)]
      this.po = [...new Set(this.po)]
      this.supplier = [...new Set(this.supplier)]
      this.brand = [...new Set(this.brand)]
      this.description = [...new Set(this.description)]
      // this.orderQty = [...new Set(this.orderQty)]
      for (const argument of this.orderQty) {
        this.orderQtySum += argument
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.item = []
      this.po = []
      this.supplier = []
      this.brand = []
      this.description = []
      this.orderQty = []
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.item.push(this.multipleSelection[i].item)
        this.po.push(this.multipleSelection[i].po)
        this.supplier.push(this.multipleSelection[i].supplier)
        this.brand.push(this.multipleSelection[i].brand)
        this.description.push(this.multipleSelection[i].description)
        this.orderQty.push(this.multipleSelection[i].orderQty)
      }
      console.log(this.multipleSelection)
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .table-body {
    width: 100%;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    td {
      table-layout: fixed;
      border-collapse: collapse;
      border-top: 1px solid #999;
      border-left: 1px solid #999;
      border-spacing: 0;
    }
  }
  .section-header {
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    background-color: rgb(192,192,192);
  }
  /deep/ .el-input__inner{
    /*border-radius: 0px;*/
    border: none;
  }
</style>
